angular.module('cloudX').directive('editableEnumPicker', [
  'editableDirectiveFactory',
  '$timeout',
  function(editableDirectiveFactory, $timeout) {
    var dir = editableDirectiveFactory({
      directiveName: 'editableEnumPicker',
      inputTpl:
        '<cx-enum-picker autofocus="true" type="{{type}}" placeholder={{placeholder}}></cx-enum-picker>',
      render: function() {
        this.parent.render.call(this);
      },
      autosubmit: function() {
        var self = this;

        self.editorEl.on('keyup', function(e) {
          if (!self.single) {
            return;
          }
          switch (e.keyCode) {
            // hide on `escape` press
            case 27:
              self.scope.$apply(function() {
                self.scope.$form.$cancel();
              });
              break;
          }
        });
      },
    });
    return dir;
  },
]);
